import { rootApi } from "../../api/rootApi";

export const webFeedbackApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllWebFeedback: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/webFeedback`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body:params.body
        };
      },
    }),

    fetchWebFeedbackById: builder.mutation({
        query: (params) => {
          return {
            method: "GET",
            url: `/app/webFeedback/${params.id}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
        },
      }),


  }),
});

export const { useFetchAllWebFeedbackMutation,useFetchWebFeedbackByIdMutation } =
webFeedbackApi;
